import Vue from 'vue'
import Vuex from 'vuex'
import config from './modules/config'
import shoppingCart from './modules/shoppingCart'
import site from './modules/site'

Vue.use(Vuex)

export default () => {
  const store = new Vuex.Store({
    modules: {
      config,
      site,
      shoppingCart
    },
    state: {},
    mutations: {},
    actions: {}
  })

  return store
}
